import { render, staticRenderFns } from "./ClientMembers.vue?vue&type=template&id=661c515c&"
import script from "./ClientMembers.vue?vue&type=script&lang=js&"
export * from "./ClientMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports